import React from 'react';
import { Link } from 'react-router-dom';
import useSettings from '../../hooks/useSettings';

const BrutalistFooter = () => {
  const currentYear = new Date().getFullYear();
  const { items: s } = useSettings();
  // Адаптация под старый интерфейс компонента — собираем contactInfo/legalInfo из settings
  const contactInfo = {
    phone: s.contact_phone,
    phoneRaw: s.contact_phone_raw,
    email: s.contact_email,
    address: s.contact_address_short,
  };
  const legalInfo = { name: s.legal_name, inn: s.legal_inn, ogrn: s.legal_ogrn };
  const companyDescription = s.company_description;

  return (
    <footer className="bg-foreground text-background pt-24 pb-8 rounded-t-[2rem] md:rounded-t-[4rem] overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        
        <div className="mb-16 flex flex-col items-start">
          <Link to="/" className="flex flex-col items-start group">
            <img 
              src="/images/logo.png" 
              alt="Кладоффка24"
              className="h-36 w-auto mb-2 brightness-0 invert opacity-90 group-hover:opacity-100 transition-opacity" 
            />

          </Link>
          <p className="mt-6 text-muted-foreground max-w-md text-lg leading-relaxed">
            {companyDescription}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-12 md:mb-24">
          <div>
            <h4 className="font-mono text-xs text-muted-foreground uppercase mb-6 tracking-widest">Компания</h4>
            <ul className="space-y-4 font-sans text-base md:text-lg">
              <li><Link to="/about" className="hover:text-accent transition-colors">О нас</Link></li>
              <li><Link to="/contacts" className="hover:text-accent transition-colors">Контакты</Link></li>
              <li><Link to="/faq" className="hover:text-accent transition-colors">FAQ</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-mono text-xs text-muted-foreground uppercase mb-6 tracking-widest">Боксы</h4>
            <ul className="space-y-4 font-sans text-base md:text-lg">
              <li><Link to="/catalog" className="hover:text-accent transition-colors">Каталог</Link></li>
              <li><Link to="/tariffs" className="hover:text-accent transition-colors">Тарифы</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-mono text-xs text-muted-foreground uppercase mb-6 tracking-widest">Документы</h4>
            <ul className="space-y-4 font-sans text-base md:text-lg">
              <li><Link to="/privacy" className="hover:text-accent transition-colors">Политика</Link></li>
              <li><Link to="/oferta" className="hover:text-accent transition-colors">Оферта</Link></li>
              <li><Link to="/rules" className="hover:text-accent transition-colors">Правила</Link></li>
              <li><Link to="/recurring" className="hover:text-accent transition-colors">Автопродление</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-xs text-muted-foreground uppercase mb-6 tracking-widest">Связь</h4>
            <a href={`tel:${contactInfo.phone}`} className="font-sans text-xl md:text-2xl font-bold mb-2 whitespace-nowrap block hover:text-accent transition-colors">
              {contactInfo.phone}
            </a>
            <a href={`mailto:${contactInfo.email}`} className="font-mono text-sm text-muted-foreground break-all hover:text-accent transition-colors">
              {contactInfo.email}
            </a>
            <a
              href="https://max.ru/id7751237158_2_bot"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-[#005FF9] text-white font-mono text-xs uppercase tracking-wider hover:bg-[#0050d4] transition-colors"
            >
              Написать в Max →
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 font-mono text-xs text-muted-foreground uppercase">
          <div>© {currentYear} {legalInfo.name}. ВСЕ ПРАВА ЗАЩИЩЕНЫ.</div>
          <div><span className="text-background/70">ИНН:</span> {legalInfo.inn}</div>
        </div>

      </div>
    </footer>
  );
};

export default BrutalistFooter;
